import { addTraits } from 'src/api';

export const getAccounts = state => addTraits(state.account.accounts);
